module.exports = __webpack_public_path__ + "img/arrow-select.024ad660.svg";